const mutations = {
  ["SET_WIDGETS"](state, payload) {
    state.AllWidgets = payload;
  },
  ["SET_WIDGETS_ALL"](state, payload) {
    state.AllAllWidgets = payload;
  },
  ["SET_DRAFTID"](state, payload) {
    state.draftID = payload[1].data.data.id;
  },
  ["SET_WIDGET"](state, payload) {
    state.widgetStateData = payload[1].data;
  },
  ["CLEAR_WIDGET"](state) {
    state.widgetStateData = {};
  },
  ["SET_PAGE_BY_NAME"]() {
    // console.log("set page");
  }
};

export default mutations;
